import { useQuery } from '@tanstack/react-query';
import { isEqual } from 'lodash';
import { useEffect } from 'react';
import { type EnhancedClientSummaryResponse } from '@/types/Auth';
import useAuth from './useAuth';
import useAxiosInterceptors from './useAxiosInterceptors';

export function useClientQuery() {
  const axiosPrivate = useAxiosInterceptors();
  const { setClient, client } = useAuth();

  const fetchClientApi = async () => {
    const response = await axiosPrivate.get<EnhancedClientSummaryResponse>('/clients/current');

    return response.data;
  };

  const query = useQuery<EnhancedClientSummaryResponse>({
    queryKey: ['current-client'],
    queryFn: fetchClientApi,
    enabled: true,
    retry: false,
  });

  useEffect(() => {
    if (query.isFetched && query.data) {
      const newClient = {
        client_details: query.data.client_details,
        addresses: query.data.addresses || [],
      };

      if (!isEqual(client, newClient)) {
        setClient(newClient);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query.data, client, setClient]);

  return query;
}
